import React, { useState, useEffect } from 'react';
import { useNavigate , Link, useParams } from 'react-router-dom';
import { preventClick } from '../../lib/helpers';
import { Modal } from 'react-bootstrap';
import InputField from '../layouts/elements/fields/input';
import toast from 'react-hot-toast';
//import { ReactSession } from 'react-client-session';
import { ReactSession } from '../../lib/secure_reactsession';
// import { FullPageLoadingIcon } from './../loader/full_page_loader_lcon_New';
import { FullPageLoadingIcon } from '../loader/full_page_loader_lcon_New';
import { showToast } from '../../lib/helpers';
import { getPageTitle } from '../../lib/pageTitle';

export default function CloseTest() {

    let { closing_code } = useParams();

    const [formValues, setFormValues] = useState({closing_code: closing_code});
    const [isLoading, setLoading] = useState(false);
    
    const navigate = useNavigate();

    useEffect(() => {
        cancelPayout()
        document.title = getPageTitle("Close test");
    }, []);

    const cancelPayout = () => {
        
        setLoading(true);

        var body = formValues;

        
        fetch(process.env.REACT_APP_API_END_POINT+'close-test', {
            method: 'POST',
            body: JSON.stringify(formValues),
            headers:{"Content-Type":"application/json"}
        })
        .then(res => res.json())
        .then(response => {
            setLoading(false);
            if(response.success){
              showToast(response.message,"success");
              navigate("/");
            } else {
              showToast(response.message,"error");
              navigate("/");
            }
        });
    }
    
    return (
        <div>
            {(isLoading==true) &&
            <FullPageLoadingIcon/> 
            }  
        </div>
    )
}